export default [{
  path: '/stage/memberAdmin',
  name: 'stage-memberAdmin',
  title: '新增会员',
  component: () => import('@/views/stage/template/memberAdmin/index')
}];
